/**
 * Navigation helpers for auth boundary transitions.
 *
 * @module authNavigation
 */

import type { NavigateFunction } from 'react-router-dom';
import { ROUTES } from '@/lib/routeConstants';

/**
 * Sends the user to sign-in after their authenticated session has ended.
 *
 * The current protected history entry is rewritten to the public landing page
 * first, so browser Back from sign-in lands on `/` instead of a protected route
 * that would immediately redirect back to sign-in.
 */
export function navigateToSignedOutSignIn(navigate: NavigateFunction): void {
  if (typeof window !== 'undefined') {
    window.history.replaceState(window.history.state, '', ROUTES.LANDING);
  }

  navigate(ROUTES.SIGN_IN);
}
